import {
	REQUEST_COMMENTS,
	RECEIVE_COMMENTS,
	RECEIVE_COMMENTS_ERROR,
	REQUEST_UPDATE_COMMENTS,
	RECEIVE_UPDATE_COMMENTS,
	UPDATE_COMMENTS_ERROR,
	RECEIVE_CREATE_COMMENTS,
	REQUEST_CREATE_COMMENTS,
	CREATE_COMMENTS_ERROR,
} from "../actions/commentsActionsRedux";

const initialCommentsState = {
	isFetching: false,
	items: [],
	error: null,
	action: null,
};

export const commentsReducer = (state = initialCommentsState, action) => {
	let commentsAfterUpdate = [];
	switch (action.type) {
		case REQUEST_COMMENTS:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null, action: null };
		case RECEIVE_COMMENTS:
			//sets new state and fetching ended
			return { ...state, items: action.payload, isFetching: false, error: null };
		case RECEIVE_COMMENTS_ERROR:
			//fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };

		case REQUEST_UPDATE_COMMENTS:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null, action: null };
		case RECEIVE_UPDATE_COMMENTS:
			//sets new state and fetching ended

			commentsAfterUpdate = state.items.map(comment =>
				comment._id === action.payload._id ? action.payload : comment
			);

			return {
				...state,
				action: action.payload.action,
				items: commentsAfterUpdate,
				isFetching: false,
				error: null,
			};
		case UPDATE_COMMENTS_ERROR:
			//fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };
		case REQUEST_CREATE_COMMENTS:
			return { ...state, error: null, isFetching: true, action: null };
		case RECEIVE_CREATE_COMMENTS:
			return {
				...state,
				items: [...state.items, action.payload],
				isFetching: true,
			};
		case CREATE_COMMENTS_ERROR:
			return { ...state, error: action.payload, isFetching: false };

		default:
			return state;
	}
};
